import { Link } from 'react-router-dom';
import { calculateRemainingSLATimeString } from '../../utils';

import './TrackingNumberCell.less';

export function TrackingNumberCell({ trackingNumber, timeLeft }) {
  const { timeString, isUrgent } = calculateRemainingSLATimeString(timeLeft);

  return (
    <div>
      <Link
        to={`/deliveries/${trackingNumber}/details`}
        className="br-lost-orders__tracking-number-cell__link"
        target="_blank"
      >
        {trackingNumber}
      </Link>
      {timeLeft && (
        <p
          data-is-urgent={isUrgent}
          className="br-lost-orders__tracking-number-cell__timeleft caption-lg"
        >
          {timeString}
        </p>
      )}
    </div>
  );
}
